import PropTypes from "prop-types";

/** Shared across many bond retrieval step components (VA / Trustee / Probate / Guardianship). */
export const RETRIEVE_GLOBAL_DATA_ROLE_DISABLED = {
  globalData: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  updateData: PropTypes.func.isRequired,
  role: PropTypes.string,
  isDisabled: PropTypes.bool,
};

/** Retrieval step + attorney guest flows (VA / Trustee). */
export const RETRIEVE_PLUS_IS_GUEST = {
  ...RETRIEVE_GLOBAL_DATA_ROLE_DISABLED,
  isGuest: PropTypes.bool,
};

/** VA / Trustee / Probate / Guardianship requestor-information steps. */
export const RETRIEVE_REQUESTOR_FIELDS = {
  data: PropTypes.object.isRequired,
  bondData: PropTypes.object,
  updateData: PropTypes.func.isRequired,
  role: PropTypes.string,
  isDisabled: PropTypes.bool,
};

/** Document upload steps exposing `pii_access`. */
export const RETRIEVE_PII_ACCESS = {
  ...RETRIEVE_GLOBAL_DATA_ROLE_DISABLED,
  pii_access: PropTypes.bool,
};

/** Trustee passes `uploadToADLS` as an injected dependency. */
export const RETRIEVE_PII_WITH_UPLOAD_FN = {
  ...RETRIEVE_PII_ACCESS,
  uploadToADLS: PropTypes.func.isRequired,
};
